/**
 * Object that needs to be passed so cookie can be set
 * @typedef {Object} CookieOptions
 * @property {string} params - The current location href
 * @property {string} cookieName - The name of the cookie
 */

/**
 * A function that handles setting cookies
 * @function handleSetUtmCookie
 * @param {CookieOptions} options - The options that contains the params and cookieName
 */

export function handleSetUtmCookie({ params, cookieName }) {
    if (!params.get(cookieName)) return;

    const hourInMs = 60 * 60 * 1000;
    const date = new Date();
    date.setTime(date.getTime() + hourInMs);
    const expires = `expires=${date.toUTCString()}`;

    document.cookie = `/utm/${cookieName}=${params.get(
        cookieName,
    )};${expires};path=/;SameSite=Lax`;
}
